import { FC } from 'react'
import { Field, FieldProps, FieldRenderProps, useField } from 'react-final-form'
import { FieldValidator } from 'final-form'
import { Props as CheckboxProps, Checkbox } from './Checkbox'

type Props = {
  name: string
  fieldProps?: FieldProps<boolean, FieldRenderProps<boolean, HTMLElement>>
  validate?: FieldValidator<boolean>
} & CheckboxProps

export const CheckboxField: FC<Props> = ({ name, fieldProps, validate, ...rest }) => {
  const { input } = useField<boolean>(name, { validate })

  return (
    <Field {...input} {...fieldProps} type="checkbox" value={!!input.value}>
      {({ input }) => (
        <Checkbox
          {...rest}
          checkboxProps={{
            ...input,
            onChange: (_e: React.ChangeEvent<HTMLInputElement>, checked: boolean) => input.onChange(checked),
            checked: !!input.value,
          }}
        />
      )}
    </Field>
  )
}
